var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _path, _line9, _line10, _line11, _path2, _line12, _line13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOkeOkeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1685 1904",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 838.448,
    cy: 1756.38,
    r: 121.514,
    strokeWidth: 40.5048,
    className: "svgStroke"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1537.65,
    cy: 1346.02,
    r: 121.514,
    strokeWidth: 40.5048,
    className: "svgStroke"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1529.28,
    cy: 550.866,
    r: 121.514,
    strokeWidth: 40.5048,
    className: "svgStroke"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.767,
    cy: 1348.81,
    r: 121.514,
    strokeWidth: 40.5048,
    className: "svgStroke"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.767,
    cy: 550.866,
    r: 121.514,
    strokeWidth: 40.5048,
    className: "svgStroke"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 838.448,
    cy: 147.347,
    r: 121.514,
    strokeWidth: 40.5048,
    className: "svgStroke"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 838.473,
    y1: 1620.34,
    x2: 834.398,
    y2: 935.807,
    strokeWidth: 48.6058,
    className: "svgStroke"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1412.93,
    y1: 620.902,
    x2: 829.657,
    y2: 932.789,
    strokeWidth: 48.6058,
    className: "svgStroke"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 1169.15,
    y1: 752.371,
    x2: 829.602,
    y2: 932.818,
    strokeWidth: 48.6058,
    className: "svgStroke"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 836.92,
    y1: 1336.45,
    x2: 834.131,
    y2: 912.409,
    strokeWidth: 50.2152,
    className: "svgStroke"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 838.447,
    y1: 283.533,
    x2: 838.447,
    y2: 550.865,
    strokeWidth: 48.6058,
    className: "svgStroke"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 1414.3,
    y1: 1285.17,
    x2: 1187.47,
    y2: 1163.66,
    strokeWidth: 48.6058,
    className: "svgStroke"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 255.747,
    y1: 1286.94,
    x2: 494.726,
    y2: 1157.33,
    strokeWidth: 48.6058,
    className: "svgStroke"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 258.716,
    y1: 614.588,
    x2: 837.934,
    y2: 930.526,
    strokeWidth: 48.6058,
    className: "svgStroke"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1195.4 751.836L824.363 553.764",
    strokeWidth: 48.6058,
    className: "svgStroke"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 495.768,
    y1: 725.635,
    x2: 490.108,
    y2: 1178.99,
    strokeWidth: 48.6058,
    className: "svgStroke"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 850.681,
    y1: 1352.19,
    x2: 470.661,
    y2: 1151.58,
    strokeWidth: 48.6058,
    className: "svgStroke"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 828.198,
    y1: 1351.15,
    x2: 1203.63,
    y2: 1149.19,
    strokeWidth: 48.6058,
    className: "svgStroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1182.85 730.912L1186.79 1170.83",
    strokeWidth: 48.6058,
    className: "svgStroke"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 482.467,
    y1: 745.67,
    x2: 847.386,
    y2: 553.661,
    strokeWidth: 48.6058,
    className: "svgStroke"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 505.856,
    y1: 747.952,
    x2: 851.783,
    y2: 937.654,
    strokeWidth: 50.2152,
    className: "svgStroke"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkeOkeIcon);
export default __webpack_public_path__ + "static/media/okeOkeIcon.a44fdec4.svg";
export { ForwardRef as ReactComponent };